import { render, staticRenderFns } from "./custom-image-viewer.vue?vue&type=template&id=3171adba"
import script from "./custom-image-viewer.vue?vue&type=script&lang=js"
export * from "./custom-image-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports